import { Modal } from 'antd';
import GuarantyListModal from 'pages/guaranty/guarantyListModal';
import React from 'react';
import { GuarantySelectedType } from './GuarantySelect';

export type GuarantySearchModalProps =  {
  visible: boolean;
  onCancel: () => void;
  setGuaranty?: (
    Guaranty: GuarantySelectedType
  ) => void;
};

const GuarantySearchModal = ({
  onCancel,
  visible,
  setGuaranty,
}: GuarantySearchModalProps) => {
  return (
    <Modal visible={visible} onCancel={onCancel} width={1200} destroyOnClose>
      <GuarantyListModal
        onSelect={setGuaranty}
      />
    </Modal>
  );
};

export default GuarantySearchModal;
